var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmblem = function SvgEmblem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0C9.835 0 0 9.576 0 22c0 12.475 9.835 22 22 22s22-9.577 22-22c.052-12.424-9.835-22-22-22Zm0 32.612c-5.85 0-10.56-4.607-10.56-10.56 0-6.005 4.71-10.56 10.56-10.56C27.85 11.44 32.612 16.047 32.612 22c0 6.005-4.763 10.612-10.612 10.612Z",
    fill: "#08031D"
  })));
};
export default SvgEmblem;